module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('b', [_vm._v("Joseph Nigg")]), _vm._v(" is one of the world’s leading experts on fantastical animals, and his exploration of the rich cultural lives of mythical creatures has garnered multiple awards and been translated into more than twenty languages. He is also the author of "), _c('i', [_vm._v("The Book of Gryphons, The Book of Fabulous Beasts: A Treasury of Writings from Ancient Times to the Present")]), _vm._v(", and "), _c('i', [_vm._v("How to Raise and Keep a Dragon")]), _vm._v(", among others.")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("Text copyright © Joseph Nigg 2013")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("Design and layout copyright © Ivy Press Limited 2013")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("All rights reserved. Published 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("ISBN-13: 978-0-226-92516-5 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("ISBN-13: 978-0-226-92518-9 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("DOI: 10.7208/chicago/9780226925189.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("A CIP record for this title is available at the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("Color origination by Ivy Press Reprographics.")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("Cover images: courtesy of James Ford Bell Library, University of Minnesota")]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_vm._v("This book was conceived, designed, and produced by")]), _vm._v(" "), _c('p', {
    staticClass: "cpya"
  }, [_vm._v("Ivy Press")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("210 High Street, Lewes")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("East Sussex BN7 2NS")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_vm._v("United Kingdom")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('a', {
    attrs: {
      "href": "http://www.ivypress.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.ivypress.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "cpy1"
  }, [_c('i', [_vm._v("Creative Director")]), _vm._v(" Peter Bridgewater")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('i', [_vm._v("Publisher")]), _vm._v(" Jason Hook")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('i', [_vm._v("Editorial Director")]), _vm._v(" Caroline Earle")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('i', [_vm._v("Art Director")]), _vm._v(" Michael Whitehead")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('i', [_vm._v("Designer")]), _vm._v(" Andrew Milne")]), _vm._v(" "), _c('p', {
    staticClass: "cpy"
  }, [_c('i', [_vm._v("Project Editor")]), _vm._v(" Jamie Pumfrey")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 57
// module chunks = 0